import * as z from "zod";

export const changePasswordSchema = z.object({
    username: z
    .string()
    .min(4, "아이디는 최소 4자 이상이어야 합니다.")
    .max(20, "아이디는 최대 20자까지 가능합니다.")
    .regex(/^[a-zA-Z][a-zA-Z0-9]*$/, "아이디는 영어 및 숫자만 가능하며 숫자로 시작할 수 없습니다."),
    email: z
    .string()
    .email("유효한 주소를 입력해주세요."),
    authCode: z
    .string()
    .regex(/^\d{6}$/, "인증 코드는 6자리 숫자여야 합니다.")
    .optional(),
});

// 🔹 타입 정의
export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;